import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900">为什么选择萝卜影视</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/70 hover:border-secondary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-2xl bg-secondary-100/80 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-background-50 transition-all duration-200 mb-4">
                <i className={`${feature.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}